//import React, { Component } from 'react';
import axios from 'axios';
import * as conf from "../config/config";
import { validarToken } from "./JWT";

var user = JSON.parse(sessionStorage.getItem("usuario"));
var catalogosLogObject = { nombreCatalogo: "", usuario: user? {id: user.persona.id, nombre: user.persona.nombre, aPaterno: user.persona.aPaterno, aMaterno: user.persona.aMaterno }: 0, accionFecha: null, metodo:"", data:[], request: "", error: "" };
//catalogos a excluir
const catalogosLogBlackList=["catalogosLog", "plataformasUsuariosPerfiles/username", "usuariosLog","validacionDatos/terrestre", "validacionDatos/naviera"];
export function Crud_error(ErrorCode=-99, Catalogo=""){
        switch(ErrorCode){
                case 400: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": Solicitud incorrecta";
                case 401: return "( Codigo de error: "+ErrorCode+"),   Usted no tiene permiso para acceder a "+'"'+ Catalogo +'"'+ ", Pongase en contacto con el administrador del sistema";
                case 403: return "( Codigo de error: "+ErrorCode+"),   Usted no tiene permiso para acceder a "+'"'+ Catalogo +'"'+ ", Pongase en contacto con el administrador del sistema";
                case 404: return "( Codigo de error: "+ErrorCode+"),   No se pudo acceder a "+'"'+ Catalogo +'"'+ ", intente mas tarde o pongase en contacto con el administrador del sistema";
                case 405: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": Método no permitido";
                case 408: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": Tiempo agotado, la solicitud no se llevó a cabo dentro del tiempo establecido";
                case 415: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": El servidor se niega a aceptar la solicitud porque el formato de carga útil está en un formato no compatible";
                case 500: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": Algo ha ido mal en el servidor del sitio web";
                case 502: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": Si se conecta a un servidor que actúa como una puerta de enlace o proxy, Es posible que los servidores que se comunican no están de acuerdo sobre el protocolo para intercambiar datos.";
                case 503: return "( Codigo de error: "+ErrorCode+"),   "+Catalogo+": El servicio está temporalmente no disponible";
                default: return "Error desconocido";
        }
}

export function Crud_Catalogos(endpoint="", metodo="get", params=[], id=""){
  const paginaspublicas= ['password_expirada', 'auto_recuperar_password'];
  let ban= false;
  for(let p of paginaspublicas){
    if( endpoint.includes(p) ){ ban= true; }
  }
  if( !ban ){ validarToken() }
  let instance = axios.create();
  const url= conf.api_raiz;
  if(sessionStorage.getItem('tok')){
    instance.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('tok');
    instance.defaults.headers.common['Content-Type'] = 'application/json';
    instance.defaults.headers.common['Accept'] = 'application/json';  
  }
  switch(metodo){
    case "get":
      return axios.get(url+endpoint).then(res => {
        return res.data;
      });
    case "post":
      if(params !== "" && params !== null ){
        return axios.post(url+endpoint, params).then(res => { 
          catalogosLogObject.nombreCatalogo= endpoint;
          catalogosLogObject.metodo= metodo;                                      
          catalogosLogObject.data= JSON.stringify(res.data);
          catalogosLogObject.request= JSON.stringify( params );
          if( !catalogosLogBlackList.includes(endpoint) ){ Crud_Catalogos("catalogosLog", "", "post", "", catalogosLogObject); }
          return res.data;
        }).catch(err => {
          catalogosLogObject.nombreCatalogo= endpoint;
          catalogosLogObject.metodo= metodo;
          catalogosLogObject.request= JSON.stringify( params );
          catalogosLogObject.data= null;//Response
          if( err.response ){
            catalogosLogObject.error= JSON.stringify( err.response.data );
            return err.response.data;
          } else {
            catalogosLogObject.error= JSON.stringify( { error: err} );
          }
          if( !catalogosLogBlackList.includes(endpoint) ){  Crud_Catalogos("catalogosLog", "", "post", "", catalogosLogObject); }
          return false;
        });
      }else{
        return false;
      }
    case "put":
    if(params !== "" && params !== null ){
        return axios.put(url+endpoint, params).then(res => {
          catalogosLogObject.nombreCatalogo= endpoint;
          catalogosLogObject.metodo= metodo;                                      
          catalogosLogObject.data= JSON.stringify(res.data);
          catalogosLogObject.request= JSON.stringify( params );
          if( !catalogosLogBlackList.includes(endpoint) ){ Crud_Catalogos("catalogosLog", "", "post", "", catalogosLogObject); }
          return res.data;
        }).catch(err => {
          catalogosLogObject.nombreCatalogo= endpoint;
          catalogosLogObject.metodo= metodo;
          catalogosLogObject.request= JSON.stringify( params );
          catalogosLogObject.data= null;//Response
          if( err.response ){
            catalogosLogObject.error= JSON.stringify( err.response.data);
          } else {
            catalogosLogObject.error= JSON.stringify( { error: "Error desconocido"} );
          }
          if( !catalogosLogBlackList.includes(endpoint) ){  Crud_Catalogos("catalogosLog", "", "post", "", catalogosLogObject); }
          return false;
        });
    }else{  return false; }
    case "delete":
      return axios.delete(url+endpoint+"/"+id, params).then(res => {
        catalogosLogObject.nombreCatalogo= endpoint;
        catalogosLogObject.data=JSON.stringify({ id: id,  Respuesta: res.data}) ;
        catalogosLogObject.metodo= metodo;
        catalogosLogObject.request= JSON.stringify( { id: id } );
        if( !catalogosLogBlackList.includes(endpoint) ){ Crud_Catalogos("catalogosLog", "", "post", "", catalogosLogObject); }
        return res.data;
      }).catch(err => { 
        catalogosLogObject.metodo= metodo;
        catalogosLogObject.nombreCatalogo= endpoint;
        catalogosLogObject.request= JSON.stringify( { id: id} );
        catalogosLogObject.data= null;//Response
        if( err.response ){
          catalogosLogObject.error= JSON.stringify( err.response.data );
          return err.response.data;
        } else {
          catalogosLogObject.error= JSON.stringify( { error: "Error desconocido"} );
        }
        if( !catalogosLogBlackList.includes(endpoint) ){  Crud_Catalogos("catalogosLog", "", "post", "", catalogosLogObject); }
        return false;
      });
  }
}

export default Crud_Catalogos;
